<template>
  <div class="info-not" v-show="infoNotShow">
    <div class="not-mask"></div>
    <div class="not-content">
      <i class="iconfont icon-close icon" @click="handleCloseNot"></i>
      <p class="tips-a">{{ infoText }}，请完善信息后再申请证书</p>
      <div class="come-study" @click="handleGoUserInfo">去完善信息</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'info-not',
  props: {
    infoNotShow: {
      type: Boolean,
      required: true
    },
    infoText: {
      type: String
    }
  },
  methods: {
    handleCloseNot() {
      this.$emit('CloseNot')
    },
    handleGoUserInfo() {
      this.$router.push('/customization/user-info')
    }
  }
}
</script>

<style lang="scss" scoped>
.info-not {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  .not-mask {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 5, 26, 0.4);
    z-index: 100;
  }
  .not-content {
    position: absolute;
    left: 10%;
    top: 50%;
    margin-top: -50%;
    width: 80%;
    padding: 36px 30px;
    box-sizing: border-box;
    background-color: #ffffff;
    border-radius: 12px;
    z-index: 101;
    .icon {
      position: absolute;
      right: 12px;
      top: 12px;
    }
    .tips-a {
      margin-top: 20px;
      line-height: 24px;
      font-size: 13px;
      color: #303133;
      letter-spacing: 0.5px;
      text-align: center;
    }
    .come-study {
      margin-top: 20px;
      width: 100%;
      height: 40px;
      background: linear-gradient(270deg, #4465f3, #4a86f6);
      border-radius: 20px;
      text-align: center;
      line-height: 40px;
      color: #fff;
      font-size: 14px;
      box-sizing: border-box;
    }
  }
}
</style>
